module.exports = __webpack_public_path__ + "img/quit_icon.a54a9ccc.svg";